<template>
  <v-footer
      app
      class="d-flex justify-end d-print-none"
      :color="appColor"
      dark
  >
<!--    <v-list-item class="justify-center">
      <h2 class="font-weight-bold" style="color: #ff6d81">(เปิดทดสอบ การบันทึกข้อมูลเดินทางไปปฏิบัติงาน วันที่ 16 ก.พ.
        67 - 15 มี.ค. 67) (ขยายเวลาจากเดิม 29 ก.พ. 67)</h2>
    </v-list-item>
    <v-list-item class="justify-center">
      <p style="font-weight: bold">โดยหลังจากวันที่ 15 มี.ค. 67 ข้อมูลการเดินทางไปฏิบัติงาน ที่ถูกบันทึกเข้าสู่ระบบช่วงเวลาทดสอบดังกล่าว
        จะถูกลบข้อมูลจากระบบทั้งหมด เพื่อรอเปิดใช้งานจริงอีกครั้ง !</p>
    </v-list-item>-->
    <v-list-item>
      <v-spacer></v-spacer>
      <span class="">พบปัญหาการใช้งาน ติดต่อ (ธวัชชัย) ฝ่ายเทคโนโลยีสารสนเทศ โทร. 1951</span>
    </v-list-item>
  </v-footer>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "Footer",
  methods: {
    ...mapActions({
      changeColor: 'Page/changeColor',
      changeHeaderName: 'Page/changeHeaderName',
    }),
  },
  computed: {
    ...mapGetters({
      appColor: 'Page/getColor',
      appHeaderName: 'Page/getHeaderName',
    })
  },
}
</script>

<style scoped>

</style>
